import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { PageInfoService, PageLink } from '@metronic/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '@services/base-service.service';
import { UtilitiesService } from '@services/utilities.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { TabListLabelRegistered } from '../../enum/tablist-label.enum';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TeregistrasiActiveComponent } from './teregistrasi-active/teregistrasi-active.component';
import { TeregistrasiRegisteredComponent } from './teregistrasi-registered/teregistrasi-registered.component';
import { ITabList } from '@shared/interface/tablist.interface';
import { DistributorTabStatus } from '@config/enum/distributor.enum';
import { API } from '@config/constants/api.constant';
import { TeregistrasiNonActiveComponent } from './teregistrasi-non-active/teregistrasi-non-active.component';

@Component({
  selector: 'app-teregistrasi',
  templateUrl: './teregistrasi.component.html',
  styleUrls: ['./teregistrasi.component.scss'],
})
export class TeregistrasiComponent implements OnInit, AfterViewInit, OnDestroy {
  links: Array<PageLink> = [
    {
      title: 'Distributor',
      path: '',
      isActive: false,
    },
    {
      title: '',
      path: '',
      isActive: false,
      isSeparator: true,
    },
    {
      title: 'Teregistrasi',
      path: '',
      isActive: true,
    },
  ];

  countActive = new BehaviorSubject(0);
  countRegistered = new BehaviorSubject(0);
  countNonActive = new BehaviorSubject(0);

  tabIndex: number = 0;
  tab: any | null = null;

  TabListLabel = TabListLabelRegistered;
  tabList: ITabList[] = [];

  private unsubscribe: Subscription[] = [];

  constructor(
    private pageInfoService: PageInfoService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private baseService: BaseService,
    public utilities: UtilitiesService,
    private rolePrivilegeService: RolePrivilegeService
  ) {}

  ngOnInit(): void {
    this.initTabList();
    this.initPageInfo();
    this.handlePrivilege();
  }

  ngAfterViewInit() {
    this.initGetListDataCount();
  }

  initTabList() {
    this.tabList = [
      {
        tab: 'active',
        enum: 'TAB_LIST_ACTIVE',
        labelKey: 'active',
        privilege: null,
        dataCount: this.countActive,
        component: TeregistrasiActiveComponent,
      },
      {
        tab: 'registered',
        enum: 'TAB_LIST_REGISTERED',
        labelKey: 'registered',
        privilege: null,
        dataCount: this.countRegistered,
        component: TeregistrasiRegisteredComponent,
      },
      {
        tab: 'nonactive',
        enum: 'TAB_LIST_NONACTIVATED',
        labelKey: 'nonactive',
        privilege: null,
        dataCount: this.countNonActive,
        component: TeregistrasiNonActiveComponent,
      },
    ];

    this.tab = this.activatedRoute.snapshot.params.tab;
    const _currentActiveTab = this.tabList.filter((item) => item.tab === this.tab);
    this.tabIndex = this.tabList.indexOf(_currentActiveTab[0]);
  }

  handlePrivilege() {
    this.tabList.map((tab) => (tab.privilege = this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_TEREGISTRASI', tab.enum)));
    this.changeFirstTab();
  }

  changeFirstTab() {
    const _data: { tab: string; privilege: boolean }[] = [];
    this.tabList.forEach((item) => {
      _data.push({ tab: item.tab, privilege: !!item.privilege });
    });

    if (!this.tabList[0].privilege) {
      const _changeTab = this.rolePrivilegeService.changePrivilegeUrlTab(_data, 'distributor', DistributorTabStatus.REGISTERED);
      this.router.navigate([_changeTab]).then();
    }
  }

  tabClick(e: MatTabChangeEvent) {
    this.tabIndex = e.index;

    const _tabLabel = e.tab.textLabel;
    const _indexOfTab = Object.values(TabListLabelRegistered).indexOf(_tabLabel as TabListLabelRegistered);

    const { tab } = this.tabList[_indexOfTab];

    this.router.navigate([`/distributor/teregistrasi/${tab}`]).then(() => this.initPageInfo());
  }

  initPageInfo() {
    this.pageInfoService.updateTitle(`Distributor Teregistrasi`);
    this.pageInfoService.updateBreadcrumbs(this.links);
  }

  initGetListDataCount() {
    const _dataCounterSubs = this.baseService.getData<any>(API.DISTRIBUTOR.LIST_COUNTER.ACTIVE_REGISTERED).subscribe((resp) => {
      if (!resp) return;
      const { distributor_active, distributor_waiting_kul, distributor_deactivation } = resp && resp.data;
      this.countActive.next(distributor_active);
      this.countRegistered.next(distributor_waiting_kul);
      this.countNonActive.next(distributor_deactivation ?? 0);
    });

    this.unsubscribe.push(_dataCounterSubs);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
